import {
  Box,
  Flex,
  Text,
  forwardRef,
  useDisclosure,
  useOutsideClick
} from '@chakra-ui/react'
import { createRef } from 'react'
import { useHistory } from 'react-router-dom'

import type { ILink } from '@base/@types/components/Layout/Navigator'

import NavigatorDropdown from './Dropdown'

interface INavigatorTabProps extends ILink {
  active: boolean
  isLast: boolean
  isFirst: boolean
}

const NavigatorTabScheduler = forwardRef((props: INavigatorTabProps) => {
  const dropdownRef = createRef<HTMLDivElement>()
  const history = useHistory()

  const { group, icon, path, menu, active, isLast, isFirst, external } = props

  const { isOpen, onOpen, onClose } = useDisclosure()

  useOutsideClick({
    ref: dropdownRef,
    handler: onClose
  })

  const handleClick = () => {
    if (path) {
      if (external) {
        return window.open(process.env.REACT_APP_URL_SCHENDULER, '_blank')
      } else {
        return history.push(path)
      }
    }

    onOpen()
  }

  return (
    <>
      <Box
        d="flex"
        flexDir="row"
        paddingTop="18px"
        paddingBottom="9px"
        alignItems="initial"
        justifyContent="center"
        transition="all ease .3s"
        _focus={{ boxShadow: 'none' }}
        onClick={handleClick}
      >
        <Flex
          w="28px"
          h="28px"
          cursor="pointer"
          fontSize="18px"
          borderRadius="4px"
          alignItems="center"
          justifyContent="center"
          bgColor={active ? '#f9e900' : 'rgba(255, 255, 255, 0.1)'}
          color={active ? 'green.600' : 'gray.400'}
          transition="all ease .3s"
          mr={2}
          _hover={{
            bgColor: active ? '#e3d400' : 'rgba(255, 255, 255, 0.2)'
          }}
        >
          {icon}
        </Flex>
        <Text
          cursor="pointer"
          fontSize="15px"
          transition="all ease .3s"
          color={active ? 'white' : 'gray.300'}
          _hover={{
            color: active ? 'white' : 'white'
          }}
        >
          {group}
        </Text>
      </Box>
      {!!menu && (
        <NavigatorDropdown
          id={`navlink-group-${group.split(' ').join('-').toLowerCase()}`}
          dropdownRef={dropdownRef}
          isOpen={isOpen}
          menu={menu}
          group={group}
          right={isLast}
          left={isFirst}
        />
      )}
    </>
  )
})
export default NavigatorTabScheduler
